import React from 'react'

import { EuiFormRow, EuiSpacer } from '@elastic/eui'

import { AudienceTargeting } from '../../../api/interfaces/CampaignTargeting'
import { AgeRangeTargeter, GenderTargeter, HouseholdIncomeTargeter } from '../../targeters'

type AudienceTargetingFormProps = {
  audienceTargeting: AudienceTargeting
  onAudienceTargetingChanged: (audienceTargeting: AudienceTargeting) => void
}

export const AudienceTargetingForm = ({ audienceTargeting, onAudienceTargetingChanged }: AudienceTargetingFormProps) => {
  return (
    <>
      <EuiFormRow label='Age Ranges' fullWidth>
        <AgeRangeTargeter
          ageRanges={audienceTargeting.demographics.ageRanges}
          setAgeRanges={ageRanges =>
            onAudienceTargetingChanged({
              ...audienceTargeting,
              demographics: {
                ...audienceTargeting.demographics,
                ageRanges: ageRanges
              }
            })
          }
        />
      </EuiFormRow>
      <EuiSpacer size='s' />
      <EuiFormRow label='Gender' fullWidth>
        <GenderTargeter
          genders={audienceTargeting.demographics.genders}
          setGenders={genders =>
            onAudienceTargetingChanged({
              ...audienceTargeting,
              demographics: {
                ...audienceTargeting.demographics,
                genders: genders
              }
            })
          }
        />
      </EuiFormRow>
      <EuiSpacer size='s' />
      <EuiFormRow label='Household Incomes' fullWidth>
        <HouseholdIncomeTargeter
          householdIncomes={audienceTargeting.demographics.householdIncomes}
          setHouseholdIncomes={householdIncomes =>
            onAudienceTargetingChanged({
              ...audienceTargeting,
              demographics: {
                ...audienceTargeting.demographics,
                householdIncomes: householdIncomes
              }
            })
          }
        />
      </EuiFormRow>
    </>
  )
}
